import { useContext } from 'react';

import {
  ApolloQueryResult,
  OperationVariables,
  useMutation,
} from '@apollo/client';
import { IContextMenuItem } from '@smartshell/ui-kit';
import { useNavigate } from 'react-router';

import { LocalizationContext } from 'localization';
import {
  DELETE_PROMO_CODE,
  IDeletePromoCodeRequest,
  IDeletePromoCodeResponse,
  IPromoCodesResponse,
  TPromoCodeData,
} from 'schemas';
import { openConfirmDialog } from 'services/Confirmation';
import notification from 'services/notificationService';

import s from './ContextMenuItems.module.scss';

export const useContextMenuItemsPromo = (
  refetchPromo: (
    variables?: Partial<OperationVariables>
  ) => Promise<ApolloQueryResult<IPromoCodesResponse>>
): Array<IContextMenuItem<TPromoCodeData>> => {
  const { t } = useContext(LocalizationContext);
  const navigate = useNavigate();

  const [deleteCode] = useMutation<
    IDeletePromoCodeResponse,
    IDeletePromoCodeRequest
  >(DELETE_PROMO_CODE, {
    onCompleted: (res) => {
      if (!res.deletePromoCode) return;
      refetchPromo();
    },
    onError: (error) => {
      notification.info({
        t,
        type: 'error',
        message: error?.message,
        title: t('errors.error'),
        dismiss: 5,
      });
    },
  });

  return [
    {
      key: 'edit',
      text: t('edit'),
      iconName: 'EditIcon',
      onClick: (promoCode: TPromoCodeData) =>
        navigate(`/promo-code/${promoCode.id}`),
    },
    {
      key: 'delete',
      className: s['remove-item'],
      text: t('delete'),
      iconName: 'BucketIcon',
      onClick: (promoCode: TPromoCodeData) => {
        openConfirmDialog(t, 'remove', {
          title: t('log.promo.deleted'),
          message: t('promo.delete.text', promoCode.code),
          acceptTitle: t('delete'),
          declineTitle: t('cancel'),
        }).then(({ status }) => {
          if (status === 'ACCEPTED') {
            deleteCode({ variables: { id: promoCode.id } });
          }
        });
      },
    },
  ];
};
